<template>
  <div class="page-dialog">
    <el-form
      label-width="80px"
      label-position="right"
      :inline="true"
      size="small"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item label="客户编号">
            <wly-input
              v-model="conditions.customerCode"
              input-type="customer"
              clearable
              disabled-enter
              @handleSuffixClick="openDialog($event, '客户选择')"
            />
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="产品编号">
            <wly-input
              v-model="conditions.productCode"
              input-type="product"
              clearable
              disabled-enter
              @handleSuffixClick="openDialog($event, '产品选择')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="要货单号">
            <el-input v-model="conditions.wantCode" />
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="申请起始日期">
            <el-date-picker
              v-model="conditions.startDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="申请结束日期">
            <el-date-picker
              v-model="conditions.endDate"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="btky-tr">
        <el-button type="default" size="small" icon="el-icon-refresh-right" @click="resetQuery">重置</el-button>
        <el-button type="primary" size="small" icon="el-icon-search" :loading="loading" @click="queryData(1)">查询</el-button>
      </el-row>
    </el-form>

    <div class="table-container">
      <TableCommon
        :show-header="false"
        :pagination="pagination"
        @pagination-change="handleTablePaginationChange"
      >
        <vxe-grid
          ref="gridOptions"
          v-loading="loading"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{name: 'NotData'}"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
          @cell-dblclick="cellClick"
        />
      </TableCommon>
    </div>

    <!-- 通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      title="客户选择"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showDialog">
        <product-select v-if="dialogTitle === '产品选择'" ref="dialogSelect" />
        <client-select v-else-if="dialogTitle === '客户选择'" ref="dialogSelect" />
      </template>

      <div slot="footer">
        <el-button type="default" icon="el-icon-circle-close" size="small" @click="showDialog = false">取消</el-button>
        <el-button type="primary" icon="el-icon-circle-check" size="small" @click="submitHandle">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ClientSelect from './ClientSelect.vue'
import ProductSelect from '@/components/dialog/ProductSelect.vue'
import { findDeliveryCheckSearchList } from '@/api/applyForGoods/index'
export default {
  components: { ClientSelect, ProductSelect },
  data() {
    return {
      showDialog: false,
      loading: false,
      valDate: null,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      conditions: {
        customerName: '',
        wantCode: '',
        wantEndDate: '',
        wantStartDate: ''
      },
      gridOptions: {
        columns: [
          { type: 'radio', title: '', field: 'radio', width: 30 },
          { title: '要货单号', field: 'wantCode',width:110},
          { title: '订单客户', field: 'customerName' ,width:150},
          { title: '产品描述', field: 'productDesc',width:160},
          { title: '要货数量', field: 'wantQuantity' ,width:90},
          { title: '申请时间', field: 'wantDate' ,width:140},
         // { title: '应付运费', field: 'payfreight' },
          { title: '应到货时间', field: 'shouldArrivedate' ,width:140},
          { title: '接收时间', field: 'receiptDate' ,width:140},
          { title: '到货时间', field: 'arrivedate' ,width:140},
          { title: '签收时间',field: 'signDate',width:140},
          { title: '发货仓库', field: 'warehouse' ,width:100},
          { title: '收货城市', field: 'receiveCityName' ,width:100},
          { title: '客户评价', field: 'commentResult' ,width:100},
          { title: '客户评价内容', field: 'feedbackByCustomer' ,width:100},
          { title: '签收备注', field: 'signRemark' ,width:100},
          { title: '备注', field: 'remark' ,width:150}
        ],
        data: []
      }
    }
  },
  watch: {
    valDate(nV, oV) {
      this.conditions.wantEndDate = nV ? nV[1] : ''
      this.conditions.wantStartDate = nV ? nV[0] : ''
    }
  },
  methods: {
    cellClick({ row }) {
      this.$refs.gridOptions.setRadioRow(row)
    },
    async queryData(page) {
      this.loading = true
      const params = {
        ...this.conditions,
        ...this.pagination
      }
      try {
        const { data: { Rows, Total }} = await findDeliveryCheckSearchList(params)
        this.gridOptions.data = Rows
        this.pagination.totalCount = Total
      } catch (e) {
        //
      }
      this.loading = false
    },
    async submitHandle() {
      const data = await this.$refs.dialogSelect.submitForm()
      if (data) {
        if (this.dialogTitle === '客户选择') {
          this.conditions.customerCode = data.customerCode
          this.conditions.customerName = data.customerName
        } else if (this.dialogTitle === '产品选择') {
          this.conditions.productDesc = data.description
          this.conditions.productCode = data.productCode
        }
      }
      this.showDialog = false
    },
    openDialog(e, title) {
      e.target.blur()
      this.showDialog = true
      this.dialogTitle = title
    },
    submitForm() {
      return this.$refs.gridOptions.getRadioRecord()
    },
    handleTablePaginationChange(pagination) {
      Object.assign(this.pagination, pagination)
      this.queryData()
    },
    resetQuery() {
      this.conditions = {
        customerName: '',
        wantCode: ''
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/dialog/SelectDeliver.vue